import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=540c2576&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=540c2576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c2576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540c2576')) {
      api.createRecord('540c2576', component.options)
    } else {
      api.reload('540c2576', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=540c2576&scoped=true&", function () {
      api.rerender('540c2576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V0jqQNr6L1JH/JS/comp/PopupDialog.vue"
export default component.exports